import instance from "../config/axios";
import { url, base_apis } from "../config/url";

export const scrimByCode = (data) => {
  return instance.post(`${base_apis.scrim}/byCode`, data).then((res) => {
    return res;
  });
  return instance.post(`${base_apis.scrim}/byCode`, data).then((res) => {
    return res;
  });
};

export const scrimGameType = (data) => {
  return instance.post(`${base_apis.scrim}/getGameType`, data).then((res) => {
    return res;
  });
  return instance.post(`${base_apis.scrim}/getGameType`, data).then((res) => {
    return res;
  });
};

export const rulesByScrimId = (data) => {
  return instance.post(`${base_apis.scrim}/rules/${data}`).then((res) => {
    return res;
  });
}
export const scrimGameRules = (data) => {
  return instance.post(`${base_apis.scrim}/getGameRules`, data).then((res) => {
    return res;
  });
  return instance.post(`${base_apis.scrim}/getGameRules`, data).then((res) => {
    return res;
  });
};

export const scrimGameCreate = (data) => {
  return instance.post(`${base_apis.scrim}/createScrim`, data).then((res) => {
    return res;
  });
};
export const scrimGameEdit = (data) => {
  return instance.post(`${base_apis.scrim}/editScrim`, data).then((res) => {
    return res;
  });
};
export const scrimsByGameNUser = (data) => {
  return instance.post(`${base_apis.scrim}/getScrimByUserId`, data).then((res) => {
    return res;
  });
};

// export const scrimById = (data) => {
//     return instance.post(`${base_apis.scrim}/viewScrimById`, data).then((res) => {
//       return res;
//     });
//   };


export const scrimRoomIdPass = (data) => {
  return instance.post(`${base_apis.scrim}/updateRoomIdPassword`, data).then((res) => {
    return res;
  });
};


export const scrimGetLeaderBoard = (data) => {
  return instance.post(`${base_apis.scrim}/getLeaderBorad`, data).then((res) => {
    return res;
  });
};

export const scrimGameWinners = (data) => {
  return instance.post(`${base_apis.scrim}/updateWinners`, data).then((res) => {
    return res;
  });
};
export const scrimsList = (data) => {
  return instance.post(`${base_apis.scrim}/hostScrims`, data).then((res) => {
    return res;
  });
};

export const scrimById = (data) => {
  return instance.post(`${base_apis.scrim}/viewScrimById`, data).then((res) => {
    return res;
  });
};

export const scrimUserDetails = (data) => {
  return instance.post(`${base_apis.scrim}/getUserDetail`, data).then((res) => {
    return res;
  });
};

export const scrimRules = (data) => {
  return instance.post(`${base_apis.scrim}/rules/${data}`).then((res) => {
    return res;
  });
};

export const scrimLeaderBoard = (data) => {
  return instance.post(`${base_apis.scrim}/getLeaderBorad`, data).then((res) => {
    return res;
  });
};

export const scrimJoin = (data) => {
  return instance.post(`${base_apis.scrim}/joinScrim`, data).then((res) => {
    return res;
  });
};
export const scrimSSUpload = (data) => {
  return instance.post(`${base_apis.scrim}/SSupload/${data?._id}`, data).then((res) => {
    return res;
  });
};


export const scrimHowToCreate = (data) => {
  return instance.post(`${base_apis.scrim}/howToCreateScrim`, data).then((res) => {
    return res;
  });
  return instance.post(`${base_apis.scrim}/getGameRules`, data).then((res) => {
    return res;
  });
};

export const scrimStatusUpdate = (data) => {
  return instance.post(`${base_apis.scrim}/updateStatus`, data).then((res) => {
    return res;
  });
};
